/**
 * Changelog ของระบบ — แสดงมุมล่างของ sidebar (owner/HR/หัวหน้า) ให้รู้ว่าตอนนี้
 * version ไหน อัปเดตอะไรล่าสุดเมื่อไหร่. เพิ่ม entry ใหม่ไว้ "บนสุด" ทุกครั้งที่ deploy.
 * APP_VERSION / รายการล่าสุด = CHANGELOG[0].
 */
export interface ChangelogEntry {
  version: string;
  date: string;   // "17 มิ.ย. 2569"
  time: string;   // "21:38"
  items: string[];
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: '1.20.0',
    date: '14 ก.ค. 2569',
    time: '21:30',
    items: [
      'เงินเดือน: เพิ่มตัวเลือก "ทำงานวันหยุดประเพณี = คิดเหมือนวันทำงานปกติ" (ตั้งค่า → เงินเดือนและงวด) — เปิดแล้วคนที่มาทำงานวันหยุดตามประเพณีจะได้ค่าจ้าง 1 เท่าเท่าวันทำงานปกติ ระบบไม่บวกค่าทำงานวันหยุด (OT) ให้ · คนที่ไม่มาทำงานยังได้วันหยุดปกติ · ค่าเริ่มต้นปิดไว้ (มีคำเตือนตามกฎหมายแรงงาน ม.62 ใช้เมื่อบริษัทตกลงกับพนักงานแล้ว)',
      'แก้ไข: หน้า "ตั้งค่าพื้นที่ออฟฟิศ (GPS)" ที่ HR เปิดแล้วค้างหมุนตลอด — ตอนนี้ HR เปิดและบันทึกพิกัดได้ปกติ',
      'แก้ไข: หน้าตั้งค่าที่โหลดข้อมูลไม่สำเร็จ จะแสดงข้อความผิดพลาด + ปุ่ม "ลองใหม่" แทนที่จะค้างหมุนโดยไม่บอกอะไร',
    ],
  },
  {
    version: '1.19.0',
    date: '10 ก.ค. 2569',
    time: '19:31',
    items: [
      'เช็คอิน: เพิ่มโหมดตรวจพิกัด 3 แบบ (ปิด / เรียนรู้ / บังคับ) — ตอนนี้ตั้งเป็น "เรียนรู้" พนักงานจึงไม่ติด "รอ HR ตรวจสอบ" อีก ระบบเก็บพิกัดไว้เรียนรู้ที่ตั้งออฟฟิศจากการเช็คอินจริงของหลายคน แล้วเสนอพิกัด+รัศมีให้เจ้าของกดยืนยัน (ระบบไม่เปลี่ยนพิกัดเอง)',
      'เช็คอิน: ตั้งค่าพิกัดออฟฟิศด้วยปุ่ม "ใช้ตำแหน่งปัจจุบัน" ได้แล้ว ไม่ต้องไปหาเลขจาก Google Maps',
      'พนักงาน: เพิ่ม "รูปแบบทำงาน" รายคน — ประจำออฟฟิศ / ทำงานที่บ้าน / ผสม · คนทำงานที่บ้านยังสแกนเข้า-ออกและถ่ายรูปตามปกติ แต่ไม่ถูกตรวจพิกัด',
      'ร้องเรียน: เมื่อพนักงานส่งเรื่องร้องเรียน/ร้องทุกข์/แจ้งเหตุ ระบบแจ้งเตือนเข้า LINE ของ HR และเจ้าของทันที',
      'เอกสาร: หน้าเอกสารพนักงานบอกได้แล้วว่าใครรอเซ็นสัญญาฉบับไหน พร้อมวันเริ่มงาน และดันคนที่ค้างเซ็นนานที่สุดขึ้นบนสุด',
      'สิทธิ์การลา: HR กรอก "ใช้ไปแล้วก่อนเริ่มใช้ระบบ" รายคนได้ (สำหรับคนที่ลาไปก่อนบริษัทเริ่มใช้ระบบนี้) เห็นวันคงเหลือทันทีตอนกรอก',
      'แก้ไข: วันลาครึ่งวันเคยถูกตัดสิทธิ์เป็นเต็มวัน · วันพักร้อนที่ยกยอดจากปีก่อนเคยไม่ถูกบวกเข้าสิทธิ์ — ทั้งสองอย่างแก้แล้ว วันคงเหลือของพนักงานบางคนจะเพิ่มขึ้นให้ถูกต้อง',
      'แก้ไข: การแจ้งเตือนใกล้ปิดงวดเงินเดือนและงานประจำวันของระบบไม่เคยทำงานเลย ตอนนี้ทำงานแล้ว',
    ],
  },
  {
    version: '1.18.6',
    date: '8 ก.ค. 2569',
    time: '22:10',
    items: [
      'รับพนักงานใหม่: เริ่มรับเข้าพนักงานที่สถานะ "รอยืนยันตัวตน" ได้แล้ว (เดิมขึ้นเฉพาะทำงานอยู่/ทดลองงาน) — เก็บเอกสาร/ตั้งค่าก่อนเริ่มงานจริงได้เลย',
    ],
  },
  {
    version: '1.18.5',
    date: '8 ก.ค. 2569',
    time: '21:40',
    items: [
      'พนักงาน: หน้าแก้ไขโชว์ "กรอกข้อมูลแล้ว X%" + ปุ่ม "แจ้งเตือนให้กรอก" (ส่ง LINE ให้พนักงานเข้ามากรอกข้อมูล/แนบเอกสารให้ครบ เมื่อยังไม่ครบ 100%)',
      'รับพนักงานใหม่: โมดอล "เลือกพนักงานที่จะเริ่มรับเข้า" ค้นหาชื่อ/รหัสพนักงานได้แล้ว',
    ],
  },
  {
    version: '1.18.4',
    date: '8 ก.ค. 2569',
    time: '21:20',
    items: [
      'เอกสาร: เอกสารบังคับ 3 อย่าง (บัตรประชาชน / สำเนาทะเบียนบ้าน / สมุดบัญชีธนาคาร) ติดป้าย "บังคับ" ในแท็บเอกสาร · เอกสารอื่นขึ้น "ถ้ามี" (แนบได้ถ้ามี) · ตารางติดตาม + ปุ่มทวงครอบสมุดบัญชีธนาคารด้วยแล้ว',
    ],
  },
  {
    version: '1.18.3',
    date: '8 ก.ค. 2569',
    time: '21:00',
    items: [
      'พนักงาน: รวมเรื่องเงินไว้แท็บเดียว "การเงิน" — เงินเดือน/ธนาคาร · ภาษี/ประกันสังคม · ค่าคอม/การจ่าย · เงินเพิ่ม/เงินหัก (เหลือ 9 แท็บ ดูง่ายขึ้น)',
    ],
  },
  {
    version: '1.18.2',
    date: '8 ก.ค. 2569',
    time: '20:40',
    items: [
      'พนักงาน: หน้าแก้ไขแบ่งเป็นแท็บย่อยให้ดูง่าย ไม่ยาวรวด — ส่วนตัว / การติดต่อ / งาน / ภาษี-ประกันสังคม / ค่าคอม-การจ่าย / เงินเพิ่ม-หัก / วันหยุด-ตารางเวร / วันลาคงเหลือ / การศึกษา / เอกสาร / ระบบ',
      'พนักงาน: เพิ่มแท็บ "วันลาคงเหลือ" แสดงสิทธิ์วันลาปีนี้ (ป่วย/กิจ/พักร้อน + ยกมา)',
    ],
  },
  {
    version: '1.18.1',
    date: '8 ก.ค. 2569',
    time: '20:00',
    items: [
      'พนักงาน: หน้าแก้ไข (เต็มจอ) ยังเห็นเมนูซ้ายอยู่ ไม่บังทั้งจอ',
      'เอกสาร: แท็บเอกสารแสดงเป็นช่องตามชื่อเอกสารที่ต้องมี — บัตรประชาชน / สำเนาทะเบียนบ้าน / Transcript / ใบตรวจร่างกาย / สัญญาจ้าง / สัญญาแนบท้าย · แต่ละช่องกดแนบไฟล์ได้เลย เห็นว่ามี/ยังไม่มี + แนบซ้ำเก็บเป็นเวอร์ชันใหม่',
    ],
  },
  {
    version: '1.18.0',
    date: '8 ก.ค. 2569',
    time: '18:30',
    items: [
      'รับพนักงานใหม่: เมนูใหม่ "รับพนักงานใหม่" — เช็คลิสต์ที่ตั้งค่าได้ (เอกสารที่ต้องส่ง / ตั้งค่าที่ต้องทำ / เอกสารที่ต้องเซ็น) · ระบบติ๊กให้อัตโนมัติเมื่อพนักงานอัปโหลดเอกสาร/ตั้งเงินเดือน/ผูก LINE/เซ็นสัญญา · พนักงานสร้างใหม่โผล่ในแดชบอร์ดเอง + หน้า "สิ่งที่ต้องทำ" ฝั่งพนักงาน',
      'พนักงาน: หน้าแก้ไขข้อมูลเป็นแบบเต็มจอ (แทนหน้าต่างเล็ก) + แยกแท็บ "ข้อมูลพนักงาน" กับ "เอกสาร" ให้ดูง่ายขึ้น',
      'เอกสาร: แยกเอกสารส่วนตัวพนักงาน (ทวงได้) ออกจากเอกสารบริษัท เช่น สัญญาจ้าง (ไม่ทวง)',
    ],
  },
  {
    version: '1.17.0',
    date: '8 ก.ค. 2569',
    time: '16:00',
    items: [
      'เอกสารพนักงาน: เมนูใหม่ "เอกสารพนักงาน" (เจ้าของ/HR) — เก็บเอกสารรายคนแบบมีประวัติเวอร์ชัน (บัตรประชาชน/ทะเบียนบ้าน/สัญญาจ้าง/หนังสือเตือน/เลิกจ้าง) พร้อมวันเวลาที่อัปโหลด · ตารางติดตามว่าใครยังขาดเอกสารอะไร + ปุ่มทวงผ่าน LINE',
      'เอกสารพนักงาน: สร้างสัญญาจ้างจากข้อมูลในระบบแล้วส่งให้พนักงานเซ็นได้เลย — พนักงานเซ็นบนจอในแอป หรืออัปรูปเอกสารที่เซ็นแล้ว (บันทึกวันเวลาที่เซ็น)',
      'เงินเดือน: ตั้ง "มีค่าคอมมิชชั่น" รายคนได้ — คนมีค่าคอม งวดเงินเดือนจ่ายแค่ฐาน + ภาษี/ปกส. ส่วนรายการหัก (สาย/ลา/ขาด) + OT + เงินเพิ่ม/หัก ย้ายไปหักตอนจ่ายค่าคอม (หน้าเงินเดือนสรุปยอดที่ต้องย้ายให้) · คนไม่มีค่าคอม = หักจากเงินเดือนตามเดิม',
      'เงินเดือน: แก้ปุ่ม "หักภาษี ณ ที่จ่าย" รายคน ที่เดิมติ๊กแล้วไม่บันทึก — ตอนนี้บันทึกได้จริง',
    ],
  },
  {
    version: '1.16.0',
    date: '2 ก.ค. 2569',
    time: '00:40',
    items: [
      'เงินเดือน: นำเข้าไฟล์แล้ว "พักคนที่ไม่อยู่ในไฟล์" อัตโนมัติ (ไม่คิดเงินเดือนงวดนั้น) — ไฟล์นำเข้าเป็นตัวกำหนดว่าใครได้เงินเดือนงวดนี้ · หน้ายืนยันบอกจำนวนคนที่จะพัก · นำเข้าไฟล์ที่มีชื่อเขาอีกครั้ง = กลับมาคิดปกติ',
      'เงินเดือน: โหมด "ไม่คิดภาษี/ประกันสังคมอัตโนมัติ" — ปิดการจำกัดหักตามมาตรา 76 (หักได้เต็มตามที่กรอกในไฟล์ ไม่มียอดยกไปงวดหน้า)',
      'เงินเดือน: แก้บั๊กนำเข้าเงินเดือนแล้วค่าเก่าไม่อัปเดต (ล้างแถวเงินเดือนเก่าที่ทับซ้อนก่อนลงค่าใหม่)',
    ],
  },
  {
    version: '1.15.0',
    date: '1 ก.ค. 2569',
    time: '22:30',
    items: [
      'เงินเดือน: ปุ่ม "เทมเพลต" ดาวน์โหลดเป็น Excel (.xlsx) พร้อม 3 คอลัมน์สรุปท้ายตาราง — รวมรายได้ / รวมรายการหัก / คงเหลือสุทธิ (สูตรคำนวณอัตโนมัติ) → กรอกตัวเลขแล้วเห็นสุทธิทันที ตรวจง่ายก่อนอัพโหลด · ตอนนำเข้าระบบข้ามคอลัมน์สรุปให้เอง',
      'เงินเดือน: นำเข้าเร็วขึ้นมาก (ตั้งเงินเดือนหลายคนพร้อมกัน) + นำเข้าซ้ำไม่เกิดรายการซ้ำสะสมอีก (ลบของเดิมก่อนลงใหม่)',
    ],
  },
  {
    version: '1.14.0',
    date: '1 ก.ค. 2569',
    time: '15:30',
    items: [
      'เงินเดือน: นำเข้าไฟล์แบบ "แจงรายการ" — ในไฟล์เดียว ใส่คอลัมน์ "เพิ่ม:ชื่อ" (เงินเพิ่ม) และ "หัก:ชื่อ" (เงินหัก) ได้ไม่จำกัด เช่น หัก:ประกันสังคม / หัก:ภาษี / หัก:หัก 3% / เพิ่ม:ค่าคอม — แต่ละคอลัมน์ = 1 บรรทัดในสลิป (แจงให้เห็นครบ) · เพิ่ม/ลบคอลัมน์เองได้',
      'ตั้งค่า: เพิ่มโหมด "ไม่คิดภาษี/ประกันสังคมอัตโนมัติ (กรอกเองในไฟล์)" — เปิดแล้วระบบจะไม่คำนวณ ภาษี/ปกส./PF ให้ ใช้ตัวเลขจากไฟล์นำเข้าล้วน · สุทธิ = เงินเดือน + เงินเพิ่มที่กรอก − เงินหักที่กรอก (คุมยอดเองทั้งหมด ตรง Excel เป๊ะ)',
    ],
  },
  {
    version: '1.13.0',
    date: '1 ก.ค. 2569',
    time: '10:00',
    items: [
      'พนักงาน: เพิ่มช่องติ๊ก "เข้าประกันสังคม (หัก 5%)" รายคน (ในหน้าแก้ไขพนักงาน ใต้เลขประกันสังคม) — ติ๊ก = ระบบหัก ปกส. 5% (สูงสุด 875 บ./เดือน) อัตโนมัติทุกงวด · เอาออก = คนนี้ไม่หัก ปกส. · ค่าเริ่มต้น = เข้าทุกคน · ค่านี้ไม่หายเวลาปรับเงินเดือน',
      'เงินเดือน (เจ้าของ + HR): นำเข้า "ไฟล์เดียว" ตั้งเงินเดือน + เงินเพิ่ม + เงินหัก ได้พร้อมกัน — กด "เทมเพลต" ที่การ์ด "นำเข้าเงินเดือน + เงินเพิ่ม/หัก" → กรอกช่องเงินเดือน/เงินเพิ่ม/เงินหักใน Excel → เลือก "วันที่มีผล" ของเงินเดือน (ปกติ = วันที่ 1 ของงวด) → กด "นำเข้าไฟล์" → ระบบตั้งฐานเงินเดือน และลงเงินเพิ่ม/หักให้ทุกคนทีเดียว · เว้นช่องเงินเดือนว่าง = ไม่แก้ของเดิม · เสร็จแล้วกด "โหลดข้อมูล" แล้ว "รันร่างใหม่"',
    ],
  },
  {
    version: '1.12.0',
    date: '29 มิ.ย. 2569',
    time: '23:00',
    items: [
      'เงินเดือน: ใส่เงินเพิ่ม/เงินหัก "หลายคนพร้อมกัน" ได้แล้ว — กด "เทมเพลต" เพื่อโหลดรายชื่อพนักงานล่าสุด → กรอกช่องเงินเพิ่ม/หักใน Excel → กด "นำเข้าหลายคน" → ระบบลงให้ทุกคนทีเดียว (เดิมต้องกดทีละคน) แล้วกดรันร่างใหม่เพื่ออัปเดตตัวเลข',
    ],
  },
  {
    version: '1.11.0',
    date: '28 มิ.ย. 2569',
    time: '11:30',
    items: [
      'เพิ่มเมนู "ขอเปลี่ยนกะการทำงาน" (พนักงาน) — ขอเปลี่ยนกะของตัวเองในวันหนึ่ง เช่น เข้า 08:00 → เข้า 12:00 · อนุมัติ 2 ชั้น (หัวหน้า → HR) เหมือนย้ายวันหยุด · ถ้ากระชั้น (ไม่ครบล่วงหน้า 1 วัน) = กระทันหัน ต้องระบุเหตุผล ให้ HR อนุมัติ · อนุมัติแล้วเขียนทับกะของวันนั้นให้อัตโนมัติ',
      'ปฏิทินเวรทีม: แก้ให้ HR/เจ้าของเห็นเวรพนักงานครบทุกคน "เต็มเดือน" (เดิมถ้าข้อมูลเวรเยอะจะแสดงไม่ครบ)',
      'ตั้งค่าเวลา: ช่อง "วันหยุดประจำสัปดาห์" เว้นว่างได้ = บริษัททำงานทุกวัน ไม่มีวันหยุดประจำสัปดาห์',
    ],
  },
  {
    version: '1.10.0',
    date: '26 มิ.ย. 2569',
    time: '11:30',
    items: [
      'ขอย้ายวันหยุด: รองรับสายอนุมัติ 2 ชั้น — หัวหน้าอนุมัติแล้ววิ่งต่อให้ผู้อนุมัติชั้น 2 (เช่น HR) ยืนยันอีกที (ตั้งจำนวนชั้นที่ "ตั้งค่าสายอนุมัติ"); พนักงานที่ไม่มีหัวหน้าให้ HR/เจ้าของอนุมัติชั้นเดียว',
      'แจ้งเตือนเจ้าของเข้า LINE "ทุกครั้ง" ที่มีคำขอใหม่ (ลา / OT / ย้ายวันหยุด) — เปิด/ปิดได้ที่ "ตั้งค่าการแจ้งเตือน"',
      'แก้กะกลางคืน (ข้ามวัน) ที่เคยบันทึกเวลาเข้า–ออกสลับกัน — เข้าตอนดึก/ออกตอนเช้าจะลงวันเดียวกันถูกต้อง คิดชั่วโมงตรง',
      'ดาวน์โหลดเทมเพลตตารางเวร: ได้ "ตารางเปล่า" ของเดือนที่เลือก (ไม่ดึงกะเดือนก่อนมาใส่ให้)',
      'เพิ่มเมนู "เจ้าของระบบ (Owner)" — เจ้าของตั้งคนอื่นเป็นเจ้าของเพิ่มได้ (หลายคน) เฉพาะเจ้าของเท่านั้นที่ทำได้',
      'พนักงานที่ลาออก/พ้นสภาพ: ตัดออกจากไฟล์จัดกะอัตโนมัติ + ลบกะ/คำขอในอนาคตที่ค้าง ไม่ให้ค้างในปฏิทินเวร',
    ],
  },
  {
    version: '1.9.0',
    date: '21 มิ.ย. 2569',
    time: '16:43',
    items: [
      'หัวหน้างาน (Supervisor) เห็นเมนูจัดการทีม (เข้างานวันนี้ / ประวัติเข้างานรายคน / กะการทำงาน / นำเข้าตารางเวร / แดชบอร์ด) — ดูได้เฉพาะลูกทีมในสายบังคับบัญชาตัวเอง',
      'เปลี่ยนชื่อบริษัทเป็น "มั่งมีทรัพย์168" ทั้งในระบบและเอกสาร (สลิป / หนังสือรับรอง)',
      'ล็อกการเช็คอิน–เช็คเอาท์ กันกดซ้ำ (เข้างาน/เลิกงาน บันทึกได้ครั้งเดียวต่อวัน) — ถ้าผิดพลาดใช้เมนู "รับรองเวลาเข้างาน" แทน',
      'เพิ่มเมนู "รับรองเวลาเข้างาน" — พนักงานขอแก้/รับรองเวลาเข้า-ออกงาน (ลืมตอก/ตอกผิด) แล้วให้ HR อนุมัติ',
      'จัดกะ: เตือน + บล็อกการลงเวรทำงานทับวันที่พนักงานลาไว้แล้ว (ลาทุกประเภทที่อนุมัติแล้ว) — มีป้าย "ลา" ในปฏิทินเวร',
      'ขอย้ายวันหยุด: เลือกกะของวันที่กลับมาทำงานได้ + ถ้าแจ้งกระชั้น (ไม่ครบล่วงหน้า 1 วัน) ระบบจะตั้งเป็น "กระทันหัน" ต้องระบุเหตุผล และให้ HR อนุมัติ',
    ],
  },
  {
    version: '1.8.0',
    date: '19 มิ.ย. 2569',
    time: '12:30',
    items: [
      'เพิ่มเมนู "หนังสือรับรอง" — ออกหนังสือรับรองการทำงาน / รับรองเงินเดือน เป็น PDF (หัวบริษัท + โลโก้ + ลายเซ็น)',
      'แก้บั๊กสลิปงวดที่จ่ายค่าคอมแล้วแต่ยังขึ้น "พรีวิว · รอค่าคอม" — ตอนนี้โหลดสลิปได้ทุกคนเมื่อบริษัทจ่ายค่าคอมงวดนั้นครบ',
      'หน้าลาออก/เลิกจ้าง: เพิ่มปุ่ม "ออกจากงานเลย" กดแล้วระบบคำนวณให้ทันทีแล้วให้ยืนยัน (หรือกด "คำนวณดูก่อน" ตรวจยอดก่อนก็ได้)',
    ],
  },
  {
    version: '1.7.0',
    date: '18 มิ.ย. 2569',
    time: '23:56',
    items: [
      'หน้าลาออก/เลิกจ้าง: บันทึกแล้วเด้งป๊อปอัป "บันทึกข้อมูลการลาออกสำเร็จ" แล้วล้างฟอร์มให้พร้อมทำคนต่อไป',
      'ฝ่ายบุคคล (HR) เพิ่มพนักงานได้แล้ว — เมนูเพิ่มพนักงาน / นำเข้าพนักงาน (Excel, ชื่อ+เลขบัตร) เปิดให้ HR',
    ],
  },
  {
    version: '1.6.0',
    date: '17 มิ.ย. 2569',
    time: '21:53',
    items: [
      'แดชบอร์ด: เพิ่มการ์ดสรุป Top 5 พนักงานมาสาย / ลางาน ของงวด (เลือกเดือนได้)',
      'เพิ่มป้ายเวอร์ชัน + ประวัติการอัปเดตระบบ (มุมล่าง sidebar)',
    ],
  },
  {
    version: '1.5.0',
    date: '17 มิ.ย. 2569',
    time: '21:38',
    items: [
      'แจ้งเตือนเจ้าของ (รับทราบ) เมื่ออนุมัติใบลา/OT เสร็จ — เป็น LINE flex card',
      'เพิ่มเมนูตั้งค่าแจ้งเตือนของเจ้าของ (เปิด/ปิดรายเรื่องได้)',
    ],
  },
  {
    version: '1.4.0',
    date: '17 มิ.ย. 2569',
    time: '21:00',
    items: [
      'สลิปเงินเดือนรวมเป็น "งวดเดียว" (เงินเดือน + ค่าคอม) — โหลดได้เมื่อจ่ายค่าคอม หรือ HR อนุมัติออกสลิป',
      'วันหยุดประเพณี = วันทำงาน (ไม่แสดงเป็นวันหยุด · มาทำงานได้ค่าแรง +1 เท่า)',
      'หัวหน้างานจัดกะได้เฉพาะทีมในสายงานตัวเอง (เมนู "จัดกะทีมงาน")',
    ],
  },
  {
    version: '1.3.0',
    date: '16 มิ.ย. 2569',
    time: '14:00',
    items: [
      'สลิปเงินเดือนออกแบบใหม่ — เอกสารทางการ ขาว-ดำ + โลโก้บริษัท',
      'สลิปขึ้นหัวตามประเภท: "สลิปค่าคอมมิชชั่น" / "สลิปเงินเดือน"',
      'แก้บั๊กปฏิทิน: วันหยุดที่ลงไว้แสดงเป็นวันหยุดถูกต้อง (ทั้งปฏิทินและเงินเดือน)',
    ],
  },
  {
    version: '1.2.0',
    date: '16 มิ.ย. 2569',
    time: '11:00',
    items: [
      'หน้า "ประวัติการจ่ายเงินเดือน" รวมเงินเดือน + ค่าคอมไว้ที่เดียว',
      'แสดงชื่อ-นามสกุลพนักงาน (เดิมแสดงแต่รหัส) · คลิกชื่อดูสลิปเป็น popup',
    ],
  },
  {
    version: '1.1.0',
    date: '16 มิ.ย. 2569',
    time: '09:00',
    items: [
      'นำเข้าเงินเดือน + ค่าคอม งวดพฤษภาคม 2569 เข้าระบบ',
      'รวมเมนูสลิปของพนักงานเป็น "สลิปเงินเดือน" เมนูเดียว',
    ],
  },
];

const latest = CHANGELOG[0]!;
export const APP_VERSION = latest.version;
export const LAST_UPDATED = `${latest.date} ${latest.time} น.`;
